import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

const FEATURE_KEY = 'network';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface NetworkState {
  maintenanceMode: boolean;
}

const initialState: NetworkState = {
  maintenanceMode: false,
};

const networkSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setMaintenanceMode: (state, action: PayloadAction<boolean>) => {
      state.maintenanceMode = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = networkSlice.reducer;
const actions = networkSlice.actions;

const state = (rootState: any): NetworkState => rootState[FEATURE_KEY];

const isInMaintenanceMode = createSelector(state, (state) => {
  return state.maintenanceMode;
});

export { actions, reducer, isInMaintenanceMode };
